export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Başlatma hatası",
    "StaticConfigLoader.caption.init": "Başlatma",
    "StaticConfigLoader.text.init": "Uygulama başlatılıyor...",
    "StaticConfigLoader.error.settings": "Site ayarları yüklenemiyor",
    "StaticConfigLoader.error.circuits": "Hizmet yapılandırması yüklenemiyor",
    //app
    "Legal.Localization": "tr",
    "AchievementApp.Navbar.storeTitle": "Mağaza",
    "AchievementApp.Navbar.supportTitle": "Destek",
    "Legal.TermsConditions": "Hüküm ve Koşullar",
    "Legal.TermsService": "Hizmet Koşulları",
    "Legal.PrivacyPolicy": "Gizlilik Politikası",
    "Legal.CookiesPolicy": "Tanımlama Bilgileri Ayarları",
    "Legal.Copyright": "Tüm ticari markalar, logolar ve ticari adlar, ilgili sahiplerinin mülkiyetindedir.",
    "AchievementApp.Navbar.achievement": "Kişisel başarı",
    "AchievementApp.Navbar.userAchievement": "Kullanıcı başarısı",
    "AchievementApp.Navbar.settingsLink": "Ayarlar",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Tekrar giriş yap veya hesabı değiştir",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net Başarıları",
    //commonAssets
    "ViewItemDetailed.state.completed": "Tamamlandı",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Başlıklara göre sırala",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Arkadaşlarım",
    "UserFriendsList.heading.showMore": "Daha fazla göster",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "İki faktörlü doğrulamayı yapılandırmalısın",
    "LimitedAccountPanel.2step.link": "İki faktörlü doğrulama hakkında daha fazla bilgi",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "E-posta adresinizi onaylamalısın",
    "LimitedAccountPanel.email.link": "Profile git",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Hesabın şu yüzden sınırlandırıldı:",
    "LimitedAccountPanel.conclusion": "Güvenlik ayarlarını değiştirdikten sonra, değişikliklerin etkili olması için çıkış yapıp, giriş yapmalısın",
    "LimitedAccountPanel.relogin": "Tekrar giriş yapabilirsin",
    "EmailVerificationStateIcon.success": "Onaylı hesap, e-posta doğrulandı",
    "EmailVerificationStateIcon.warning": "Onaysız hesap, e-posta doğrulanmadı",
    "EmailVerificationStateIcon.danger": "Onaylı hesap, e-posta doğrulaması GEREKİYOR",
    "TwoFactorStateIcon.success": "Hesap, iki faktörlü doğrulama ile güvene alındı",
    "TwoFactorStateIcon.warning": "Güvensiz hesap, iki faktörlü doğrulama devre dışı",
    "TwoFactorStateIcon.danger": "İki faktörlü doğrulama GEREKİYOR",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Ayarları kaydet",
    "UserSettingDialog.settings": "Ayarlar",
    "UserSettingDialog.userSettings": "Kullanıcı ayarları",
    "UserSettingDialog.language": "Dil",
    "UserSettingDialog.privacy": "Gizlilik",
    "UserSettingDialog.allUsers": "Tüm kullanıcılar",
    "UserSettingDialog.friendsOnly": "Yalnızca arkadaşlar",
    "UserSettingDialog.onlyMe": "Yalnızca ben",
    "UserSettingDialog.whoCanView": "Başarılarımı kim görebilir",
    //unlockProgress
    "ViewUnlockProgress.of": " / ",
    "ViewUnlockProgress.achievCompleted": " tamamlanan başarılar",
    "ViewUnlockProgress.myUnlock": "Başarılarım",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Buradan lakap arayın",
    "ViewItemSearch.label.search": "Kullanıcıları arayın",
    "ViewItemSearch.resultNotFound": "Kullanıcı bulunamadı",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Başarı",
    "ViewItemSearch.stub.empty": "Başarı yok",
    "ViewItemSearch.stub.emptyCompare_1": "Kullanıcı ",
    "ViewItemSearch.stub.emptyCompare_2": " bu oyunda başka bir başarıya sahip değil",
    "ViewItemSearch.limitedAccess": "Seçilen kullanıcının başarılarına erişim sınırlandırılmış",
    "ViewItemSearch.heading.selectGame": "Listeden oyun seç",
    "ViewItemSearch.globalstat.opened": "Şunlar açtı: ",
    "ViewItemSearch.globalstat.ofGamers": " Oyuncuların % kadarı",
    //authentication
    "NotAllowedMessage.caption": "İzin verilmez",
    "NotAllowedMessage.body.h1": "Başarıya Erişim",
    "NotAllowedMessage.body.h3": "hesabına şu an izin verilmez",
    "NotAllowedMessage.relogin": "Hesap değiştir",
    "LandingMessage.caption": "Doğrulama",
    "LandingMessage.body": "İniş bitiriliyor...",
    "TokenExpiredMessage.caption": "Doğrulamanın süresi geçti",
    "TokenExpiredMessage.body.h3": "Bunun için yapabileceğimiz bir şey yok ancak hâlâ",
    "TokenExpiredMessage.relogin": "Tekrar giriş yap",
    "AuthErrorMessage.caption": "Doğrulama başarısız",
    "AuthErrorMessage.body.h1": "Doğrulama kontrolü başarısız",
    "AuthErrorMessage.body.code": "Kod",
    "AuthErrorMessage.body.desc": "Bunun için yapabileceğimiz bir şey yok ancak hâlâ",
    "AuthErrorMessage.relogin": "Tekrar giriş yapabilirsin",
    "AuthorizationRequiredMessage.caption": "Doğrulama gerekli",
    "AuthorizationRequiredMessage.body.h3.1": "Şuna girmek üzeresin:",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Ancak daha fazla ilerlemek için yetkili olman gerekir",
    "AuthorizationRequiredMessage.login": "Gaijin.Net ile oturum aç",
    "CheckingAuthMessage.caption": "Doğrulama",
    "CheckingAuthMessage.body": "Doğrulama kontrol ediliyor, lütfen bekle",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Mobil sürüm geçici olarak kullanılamıyor",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Lütfen masaüstü sürümü kullan",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Üzgünüz",
}